import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { useIsMobile } from 'pricing-pages-lib/context/IsMobileContext';
import { PageSection, SectionHeader, SectionSubTitle, SectionTitle } from 'pricing-pages-ui-components/semantic/PageSection';
import { AllCombinedProductLines } from 'self-service-api/constants/AllCombinedProductLines';
import { WHY_GO_HUBSPOT_SECTION } from '../constants/ErrorBoundaryNames';
import WhyGoHubSpotTile from './WhyGoHubSpotTile';
import { ERROR_SEVERITY } from './error-boundary/error-severity';
import { withErrorBoundary } from './error-boundary/withErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WhyGoHubSpotSection = ({
  selectedNavItem
}) => {
  const isMobile = useIsMobile();
  return /*#__PURE__*/_jsx(PageSection, {
    use: isMobile ? 'shaded' : 'default',
    children: /*#__PURE__*/_jsxs(View, {
      paddingBlockStart: "500",
      paddingBlockEnd: "1300",
      children: [/*#__PURE__*/_jsxs(SectionHeader, {
        maxInlineSize: "850px",
        children: [/*#__PURE__*/_jsx(SectionTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `whyGoHubSpot.${selectedNavItem}.title`
          })
        }), /*#__PURE__*/_jsx(SectionSubTitle, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `whyGoHubSpot.${selectedNavItem}.subtitle`
          })
        })]
      }), /*#__PURE__*/_jsx(View, {
        maxInlineSize: "1200px",
        children: /*#__PURE__*/_jsx(CardGrid, {
          columns: isMobile ? 1 : 3,
          gutterSize: 15,
          children: AllCombinedProductLines.map(productLine => {
            return /*#__PURE__*/_jsx(WhyGoHubSpotTile, {
              productLine: productLine
            }, productLine);
          })
        })
      })]
    })
  });
};
export default withErrorBoundary(WhyGoHubSpotSection, {
  fallback: null,
  errorBoundaryName: WHY_GO_HUBSPOT_SECTION,
  severity: ERROR_SEVERITY.LOW
});